import layout from '@/layout'

export default {
  path: '/advance_fund',
  component: layout,
  redirect: '/advance_fund/other/index',
  name: 'advance_fund_other_index',
  meta: {
    title: 'advance_fund',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: '/advance_fund/other/index',
      name: 'advance_fund_other_index',
      component: () => import('@/views/other_advance_fund/index'),
      meta: {
        title: 'advance_fund_other_index',
        icon: 'el-icon-document'
      }
    }
  ]
}
